<template lang="pug">
div
  v-card.wallpaper(flat)
    v-container.limitw
      v-row
        v-col(v-if="!$store.state.windowSize.isMobile" cols="12" sm="10" offset-sm="1" offset-md="0" md="7" lg="8")
          v-card.rounded-lg(color="transparent" style="border-radius:20px !important; box-shadow: 5px 6px 10px -5px rgba(0,0,0,0.60) !important;")
            v-responsive( :aspect-ratio="16/7")
              v-carousel(hide-delimiters height="100%" cycle interval="10000" prev-icon="fas fa-angle-left" next-icon="fas fa-angle-right")
                v-carousel-item(v-for="(item, index) in banners" :key="index")
                  a(:href="item.link" target="_blank")
                    v-img(:src="item.imagen")
        v-col(cols="12" sm="8" offset-sm="2" offset-md="0" md="5" lg="4")
          v-card(dark).rounded-xl.login-panel.elevation-5
            v-card-text.pa-0(style="height: auto;")
              //- ADD VERIFICATION MAINTENANCE 2025
              c-login-form(v-if="!$store.state.isInMaintenance")
              login-form-maintenance(v-else)
            //-v-divider(v-if="!$store.state.isInMaintenance")
            v-divider(color="#BBB" style="height:2px;min-height:2px;")
            v-card-actions(v-if="!$store.state.isInMaintenance")
              //-v-menu(offset-y)
                template(v-slot:activator="{ on, attrs }")
                  v-btn.txtn(large color="blue darken-1" v-bind="attrs" v-on="on" style="height:50px;background: linear-gradient(0deg,#800 0%, #911 80%)!important;text-shadow: 0px 2px 3px rgba(0,0,0,0.6);").pl-4.pr-3
                    | Convocatorias  <br>Vigentes  
                    v-icon(size=30) fas fa-file-pdf
                v-list(dense)
                  //-v-list-item(v-for="(item, index) in items" :key="index" :href="item.ref" target="_blank")
                  v-list-item(v-for="(item, index) in items" :key="index" href="#" @click="abrirPrecargaV2(index+1)")
                    v-list-item-title.text-center {{ item.title }}
              v-btn.txtn(color="blue darken-1" @click="dialogoConvocatorias=true" style="height:50px;background: linear-gradient(0deg,#800 0%, #911 80%)!important;text-shadow: 0px 2px 3px rgba(0,0,0,0.6);").pl-4.pr-3
                | Convocatorias  <br>Vigentes  
                v-icon(size=30) fas fa-file-pdf
              v-spacer
              btn.txtn(large style="border-radius:10px;font-weight:bold;font-size:15px;line-height:18px;background: linear-gradient(0deg,#b07d01 0%, #dfa92b 80%)!important;text-shadow: 0px 2px 3px rgba(0,0,0,0.6);cursor:pointer;" @click="abrirPrecarga").pt-2.pb-2.text-center
                | Convocatorias Administrativas<br>(Personal sin RDA o sin RP-DGESTTLA)
              v-spacer
              //-v-btn(
                :loading="isLoading",
                color="#C28D11",
                style="border-radius:10px;font-weight:bold;font-size:15px;background: linear-gradient(0deg,#b07d01 0%, #dfa92b 80%)!important;",
                @click="tryLogin" large).pl-5.pr-5 Ingresar
          v-card(flat, color="transparent").mt-1
            v-card-actions.pa-0.pt-0
              v-spacer
              c-recaptcha-logo
              v-spacer
        v-col(v-if="$store.state.windowSize.isMobile" cols="12" sm="10" offset-sm="1" offset-md="0" md="7" lg="8").pa-0
          v-card(color="transparent" flat).rounded-0.mt-5
            v-responsive( :aspect-ratio="16/7")
              v-carousel(hide-delimiters height="100%" cycle prev-icon="fas fa-angle-left" next-icon="fas fa-angle-right")
                v-carousel-item(v-for="(item, index) in banners" :key="index")
                  a(:href="item.link" target="_blank")
                    v-img(:src="item.imagen")
  v-container.mt-8.limitw
    v-row
      //-v-col.text-center.pa-0(cols="12")
        v-img(src="/img/fecha-limite-inscripcion.jpg" width="500px" style="margin:-10px auto 10px auto")
      v-col.text-center.pa-0(cols="12" style="border-bottom:#960407 solid 3px;").mb-3
        div(style="display:inline;float:left;width:100%").ma-0.pa-0
          v-tabs(background-color="transparent" color="#960407" v-model="currentTab" slider-size="3" slider-color="#960407" show-arrows)
            v-tab Publicaciones
            v-tab Videos
            v-tab(@click="scrollToBTabs()") Bibliografía<br>Ascenso de Categoría
            //- INSTITUCIONALIZACION 2024 v-tab(@click="scrollToBTabs()")
              v-layout
                v-flex.text-center(xs12)
                  h4.txtn(style="line-height: 20px") Bibliografía<br>Institucionalización
            //-2023 inst v-tab(@click="scrollToBTabs()") Bibliografías
            //-v-tab(@click="scrollToBTabs()") Directrices<br>ASCENSO DE CATEGORÍA
        //-h2.title.light-blue--text.text-left.text--darken-4(style="width:200px;display:inline;float:left;").pl-4.pt-4 Publicaciones
        //-h2.title.light-blue--text.text-left.text--darken-4(style="width:200px;display:inline;float:left;").pl-4.pt-4 Videos
      v-col.pa-0(v-show="currentTab == 0")
        v-text-field(label="Buscar publicación" autocomplete="off" dense append-icon="fas fa-search" color="orange" placeholder="Buscar publicación..." solo v-model="searchTerm" @change="onChangeTerm" @keyup="onChangeTerm" style="display:inline;float:right;max-width:300px;margin-bottom:10px;" hide-details)
      //-v-col(cols=12).red.pa-0
      v-tabs-items(v-model="currentTab" style="width:100%").ma-0.pa-0.transpare2t.transparent
        v-tab-item.ma-0.pa-0(style="width:100%")
          v-col.text-center.pa-0(cols="12" v-if="filterByTerm.length == 0")
            v-alert(type="warning" color="#960407" max-width="400px").center.mt-15.mb-15 No se encontraron registros para: "{{ searchTerm }}"
          v-col.text-center.pa-0(cols="12" v-if="searchTerm.length<1")
            div(v-masonry="masonryId" transition-duration="0.4s" item-selector=".item")
              div(v-masonry-tile="masonryId" :style="masonryStyle" cols="12" md="6" v-for="(publicacion, index) in publicaciones.slice(((page-1)*limitPerPage),(page*limitPerPage))" :key="index").item.ma-0.pa-0
                c-noticia-v4(
                  :imagen="publicacion.imagen",
                  :titulo="publicacion.titulo",
                  :fecha="publicacion.fecha",
                  :description="publicacion.description",
                  :tipo="publicacion.tipo",
                  :archivo="publicacion.archivo"
                ).ma-2
          v-col.text-center.pa-0(cols="12" v-else)
            div(v-masonry="masonryIds" transition-duration="0.4s" item-selector=".item")
              div(v-masonry-tile="masonryIds" :style="masonryStyle" cols="12" md="6" v-for="(publicacion, index) in filterByTerm" :key="index").item.ma-0.pa-0
                c-noticia-v4(
                  :imagen="publicacion.imagen",
                  :titulo="publicacion.titulo",
                  :fecha="publicacion.fecha",
                  :description="publicacion.description",
                  :tipo="publicacion.tipo",
                  :archivo="publicacion.archivo"
                ).ma-2
          v-col(cols="12" v-if="pages>1 && searchTerm.length<1")
            v-pagination(v-model="page" :length="pages" :total-visible="10" color="#960407" @input="updateMan" @next="updateMan" @previous="updateMan").my-4
        v-tab-item
          v-row
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/18Xv1A7AbRxjcMDAAWa2B3PrnLfk4gUhI/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Descuentos por Faltas y Sanciones
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/1F8a1wykVFSgbTUUnR6ESCZKqTGpydLAm/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Registro de Formularios 110 - RC-IVA
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/1GcdwsAxLxVOqCAnElPr3sJrNQZxc8psw/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Inscripción Institucionalizacion 2024-2026 - Personal Sin RDA
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/1RfoJhC7CQoZNCvAUs7MraaVYGQetfPJO/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Inscripción Institucionalizacion 2024-2026 - U.E. de Convenio
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/1nd34fiEDxeYrIGfAYSI2jk1WT604-kAu/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Inscripción Institucionalizacion 2024-2026
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/10CVtG44Y2NgK1B80pirRQVrLr2SLhw1y/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Recepción, revisión y asignación de subsidio
        v-tab-item
          v-row
            v-col(cols="12").text-center.pb-4.pt-10
              p.pa-0.ma-0(style="font-size:24px;line-height:28px;").font-weight-light
                span(style="color:#960407") <b>BIBLIOGRAFÍA</b>
                | &nbsp;ASCENSO DE CATEGORÍA 2026
            v-col(cols="12").pt-0.pb-0
              //-old2025v-tabs(background-color="transparent" color="#960407" v-model="currentTabBiblio" slider-size="3" slider-color="#960407" height="64" centered show-arrows)
                v-tab(style="width:120px").pl-1.pr-1 Normativa<br>General
                v-tab(style="width:185px").pl-1.pr-1 Educación Regular<br>INICIAL Y PRIMARIA
                v-tab(style="width:185px").pl-1.pr-1 Educación Regular<br>Secundaria
                v-tab(style="width:120px").pl-1.pr-1 Educación<br>Alternativa
                v-tab(style="width:120px").pl-1.pr-1 Educación<br>Especial
                v-tab(style="width:195px").pl-1.pr-1 Educación Superior<br>DGESTTLA
                v-tab(style="width:170px").pl-1.pr-1 Administrativos
              v-tabs(background-color="transparent" color="#960407" v-model="currentTabBiblio" slider-size="3" slider-color="#960407" height="64" centered show-arrows)
                v-tab(style="width:280px").pl-1.pr-1 Maestros y Administrativos<br>VER VEAE ESFM-UA
                v-tab(style="width:310px;").pl-1.pr-1 Institutos Técnicos Tecnológicos<br>e Instituciones de Formación Artística
            v-col(cols="12" style="width:100%;height:2px;background-color:#960407;").pa-0.ma-0
            v-col(cols="12").pt-0
              v-tabs-items(v-model="currentTabBiblio" style="width:100%").ma-0.pa-0
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-normativa-general-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-regular-primaria-v2
              //-OLD2025v-tabs-items(v-model="currentTabBiblio" style="width:100%").ma-0.pa-0
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-normativa-general-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-regular-primaria-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-regular-secundaria-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-alternativa-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-especial-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-dgesttla-v2
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-administrativos-v2


        v-tab-item
          v-row(dense).pl-2.pr-2
            v-col(cols="12").text-center.pb-4.pt-8
              p.pa-0.ma-0(style="font-size:24px;line-height:28px;").font-weight-light
                apan(style="color:#0652a1;") <b>DIRECTRICES</b>
                | &nbsp;PROPUESTA TRANSFORMADORA<br>HACIA LA CALIDAD EDUCATIVA
            v-col(cols="12" md="6")
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS PROPUESTAS TRANSFORMADORAS GESTIÓN 2025<br>PERSONAL DOCENTE
                v-card-text.pt-0.pb-0
                  iframe(src="https://drive.google.com/file/d/1fETYEEfozxZwJvzLw_CwIl6Nhn0SPJLe/preview" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://drive.google.com/file/d/1fETYEEfozxZwJvzLw_CwIl6Nhn0SPJLe/view" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
            v-col(cols="12" md="6")
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS PROPUESTAS TRANSFORMADORAS GESTIÓN 2025<br>PERSONAL ADMINISTRATIVO
                v-card-text.pt-0.pb-0
                  iframe(src="https://drive.google.com/file/d/1gTvxmJ58dd6dgO21eUT2-QLXc8BkQc-q/preview" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://drive.google.com/file/d/1gTvxmJ58dd6dgO21eUT2-QLXc8BkQc-q/view" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
        //- DIRECTRICES 2023 v-tab-item
          v-row(dense).pl-2.pr-2
            v-col(cols="12").text-center.pb-4.pt-8
              p.pa-0.ma-0(style="font-size:24px;line-height:28px;").font-weight-light
                apan(style="color:#0652a1;") <b>DIRECTRICES</b>
                | &nbsp;PROPUESTA TRANSFORMADORA
            v-col(cols="12" md="6")
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS PROPUESTAS TRANSFORMADORAS GESTIÓN 2023<br>PERSONAL DOCENTE
                v-card-text.pt-0.pb-0
                  iframe(src="https://sisep.minedu.gob.bo/pdf/Directrices%20Propuestas%20Transformadoras%202023%20Docente.pdf?ver=22" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://sisep.minedu.gob.bo/pdf/Directrices%20Propuestas%20Transformadoras%202023%20Docente.pdf?ver=22" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
            v-col(cols="12" md="6")
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS PROPUESTAS TRANSFORMADORAS GESTIÓN 2023<br>PERSONAL ADMINISTRATIVO
                v-card-text.pt-0.pb-0
                  iframe(src="https://sisep.minedu.gob.bo/pdf/Directrices%20Propuestas%20Transformadoras%202023%20Administrativo.pdf?ver=22" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://sisep.minedu.gob.bo/pdf/Directrices%20Propuestas%20Transformadoras%202023%20Administrativo.pdf?ver=22" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
            //-v-col(cols="12" md="6")
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS EXPERIENCIAS TRANSFORMADORAS GESTIÓN 2022<br>PERSONAL DOCENTE
                v-card-text.pt-0.pb-0
                  iframe(src="https://cdn.jsdelivr.net/gh/ugpsep/assets/directrices/EET-2022-DOCENTE_compressed.pdf#zoom=FitH" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://github.com/ugpsep/assets/raw/main/directrices/EET-2022-DOCENTE_compressed.pdf" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
            //-v-col(cols="12" md="6").pb-8
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS EXPERIENCIAS TRANSFORMADORAS GESTIÓN 2022<br>PERSONAL ADMINISTRATIVO
                v-card-text.pt-0.pb-0
                  iframe(src="https://cdn.jsdelivr.net/gh/ugpsep/assets/directrices/EET-2022-ADMIN.pdf#zoom=FitH" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://github.com/ugpsep/assets/raw/main/directrices/EET-2022-ADMIN.pdf" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
  v-dialog(v-model="dialogoPrecarga" max-width="400" v-on:click:outside="cancelarPrecarga")
    v-card(flat color="blue" style="background-image:linear-gradient(to bottom, #2b5b84, #1e415e)")
      v-card-text.text-center.pa-0
        v-progress-circular(:rotate="270" :size="80" :width="5" :value="value" color="orange" style="margin: 2rem").ma-5
          span.white--text {{ value }} %
      v-card-text.text-center.pa-5.pt-0
        h3.white--text Cargando Formulario...
  v-dialog(v-model="dialogoPrecargaV2" max-width="400" v-on:click:outside="cancelarPrecargaV2")
    v-card(flat color="blue" style="background-image:linear-gradient(to bottom, #2b5b84, #1e415e)")
      v-card-text.text-center.pa-0
        v-progress-circular(:rotate="270" :size="80" :width="5" :value="valueV2" color="orange" style="margin: 2rem").ma-5
          span.white--text {{ valueV2 }} %
      v-card-text.text-center.pa-5.pt-0
        h3.white--text Cargando Convocatorias...
  v-dialog(v-model="dialogoFormulario" fullscreen)
    v-card(flat).rounded-0
      v-card-title.no-padding
        v-toolbar(dark style="background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);")
            v-btn(color="white" outlined style="border-radius:5px;" @click="dialogoFormulario = false").pl-3.pr-3.rounded-lg
                v-icon(size="15") fas fa-arrow-left
                | &nbsp;Volver
      v-card-text.pa-2(:style="customHeight")
        iframe(:src="theLink" width="100%" height="100%" style="overflow:hidden;" frameborder="0")
  v-dialog(v-model="dialogoFormularioV2" fullscreen)
    v-card(flat).rounded-0
      v-card-title.no-padding
        v-toolbar(dark style="background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);")
          v-btn(color="white" outlined style="border-radius:5px;" @click="dialogoFormularioV2 = false").pl-3.pr-3.rounded-lg
            v-icon(size="15") fas fa-arrow-left
            | &nbsp;Volver
      v-card-text.pa-2(:style="customHeight")
        div(style="float: left;display: inline;width: 100%;height: 100%;background-repeat:no-repeat;background-position:center center;background-image: url('https://sisep.minedu.gob.bo/img/loader.gif');padding:0px;")
          iframe(:src="theLinkV2" width="100%" height="100%" style="overflow:hidden;" frameborder="0")
  v-dialog(v-model="dialogoConvocatorias" max-width="450")
    v-card.rounded-lg(style="overflow:hidden;")
      v-card-title.no-padding
        v-toolbar(dark style="background: linear-gradient(0deg,#800 0%, #911 80%)!important;text-shadow: 0px 2px 3px rgba(0,0,0,0.6);")
          h4 Convocatorias Vigentes
          v-spacer
          v-btn(color="white" icon style="border-radius:5px;" @click="dialogoConvocatorias = false").rounded-lg
            v-icon(size="20") fas fa-times
      v-card-text.pa-0.ma-0.pb-3.pt-3
        v-row(dense no-gutters)
          v-col(cols="6")
            h4.text-center.pt-4(style="color:#811;font-size:13pt;") Educación Regular:
            v-list(dense)
              //-v-list-item(v-for="(item, index) in items" :key="index" :href="item.ref" target="_blank")
              //-v-list-item(v-for="(item, index) in items" :key="index" href="#" @click="abrirPrecargaV2(index+1)")
              v-list-item(v-for="(item, index) in items" :key="index" href="#" @click="abrirPrecargaV2(item)")
                v-list-item-title.text-center {{ item.title }}
          v-col(cols="6")
            h4.text-center.pt-4(style="color:#811;font-size:13pt;") Educación Superior:
            v-list(dense)
              //-v-list-item(v-for="(item, index) in items" :key="index" :href="item.ref" target="_blank")
              //-v-list-item(v-for="(itemV2, indexV2) in itemsV2" :key="indexV2" href="#" @click="abrirPrecargaV2(indexV2+1)")
              v-list-item(v-for="(itemV2, indexV2) in itemsV2" :key="indexV2" href="#" @click="abrirPrecargaV2(itemV2)")
                v-list-item-title.text-center {{ itemV2.title }}
  //--v-dialog(v-model="messageAlert" max-width="600px" style="border-radius:10px;")
    v-card(style="border-radius:10px;")
      v-card-actions.pa-0(style="position:relative;z-index:30000").transparent
        v-spacer
        v-btn(fab icon @click="messageAlert=false")
          v-icon fas fa-times
      v-card-text.pa-0(style="margin-top:-20px;")
        v-img(src="https://sisep.minedu.gob.bo/img/comunicado-003.png" width="100%")
</template>

<style lang="stylus">
.customTabsClass .v-window .v-window__container .v-window-item
  padding 0px !important
  margin 0px !important
.wallpaper
  //background url("/img/fox-tail2.png") top -390px center no-repeat, #000428
  background #000428
  margin-top 92px
  box-shadow 0px 0px 10px 0px rgba(0,0,0,0.18) !important
  margin-top 160px
.login-panel
  margin-top 10px
  background-image:linear-gradient(to bottom, #FFFFFF, #E0E0E0)
@media screen and (max-width: 960px)
  .login-panel
    margin-top -5px
  .wallpaper
    margin-top 115px
@media screen and (max-width: 600px)
  .login-panel
    margin-top -5px
  .wallpaper
    margin-top 165px
@media screen and (max-width: 450px)
  .login-panel
    margin-top -5px
  .wallpaper
    margin-top 200px

</style>


<script>
import { arrayExpression } from 'babel-types';
import Vue from 'vue'
export default {
  data() {
    return {
      messageAlert: false,
      /*items: [
        { title: 'Chuquisaca',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/1' },
        { title: 'La Paz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/2' },
        { title: 'Cochabamba',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/3' },
        { title: 'Oruro',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/4' },
        { title: 'Potosí',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/5' },
        { title: 'Tarija',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/6' },
        { title: 'Santa Cruz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/7' },
        { title: 'Beni',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/8' },
        { title: 'Pando',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/9' },
      ],*/
      items: [
        { title: 'Chuquisaca',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/1' },
        { title: 'La Paz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/2' },
        { title: 'Cochabamba',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/3' },
        { title: 'Oruro',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/4' },
        { title: 'Potosí',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/5' },
        { title: 'Tarija',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/6' },
        { title: 'Santa Cruz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/7' },
        { title: 'Beni',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/8' },
        { title: 'Pando',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/9' },
      ],
      itemsV2: [
        { title: 'Chuquisaca',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/1' },
        { title: 'La Paz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/2' },
        { title: 'Cochabamba',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/3' },
        { title: 'Oruro',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/4' },
        { title: 'Potosí',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/5' },
        { title: 'Tarija',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/6' },
        { title: 'Santa Cruz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/7' },
        { title: 'Beni',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/8' },
        { title: 'Pando',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento-superior-itt/9' },
      ],
      bibliografias:[],
      bibliografiasParsed:[],
      bibliografiaEducacionAyE:[],
      bibliografiasPart2:[],
      bibliografiasPart3:[],
      currentTab: 0,
      currentTabBiblio: 0,
      masonryId: 'masonry-grid-1',
      masonryIds: 'masonry-grid-2',
      searchTerm: "",
      pages: 1,
      page: 1,
      limitPerPage: 12,
      banners: [],
      publicaciones: [],
      dialogoPrecarga: false,
      dialogoPrecargaV2: false,
      dialogoFormulario: false,
      dialogoFormularioV2: false,
      dialogoConvocatorias: false,
      interval:{},
      intervalV2:{},
      dptoSelected: 1,
      value: 0,
      valueV2: 0,
      time: null,
      theLink: "/ui/ui-distrito/sin-usuario/inscripcion-a-compulsa" + "?ver=" + (Math.random() * (9999999 - 999) + 999),
      theLinkV2: ""
    }
  },
  async mounted(){
    try {
      let getPublicaciones = await axios.get("https://sisep.minedu.gob.bo/strapi/strapi-portal/publicacions?_sort=fecha:DESC,created_at:DESC&_limit=250&_start=0");
      //let getPublicaciones = await axios.get("http://100.0.102.78:8103/publicacions?_sort=created_at:DESC");
      const tmpPublicacion = [];
      for (let i = 0; i < getPublicaciones.data.length; i++) {
        const element = getPublicaciones.data[i];
        tmpPublicacion.push({
          imagen: "https://sisep.minedu.gob.bo/strapi/strapi-portal" + element.imagen.url,
          titulo: element.titulo,
          fecha: this.$store.state.formatFecha(element.fecha),
          description: element.descripcion,
          tipo: element.tipo,
          archivo: "https://sisep.minedu.gob.bo/strapi/strapi-portal" + element.archivo.url
        })
      }
      this.publicaciones = tmpPublicacion;
      this.pages = Math.ceil((this.publicaciones.length/this.limitPerPage))
      let getBanners = await axios.get("https://sisep.minedu.gob.bo/strapi/strapi-portal/banners?_sort=created_at:DESC");
      //let getBanners = await axios.get("http://100.0.102.78:8103/banners?_sort=created_at:DESC");
      const tmpBanners = [];
      for (let j = 0; j < getBanners.data.length; j++) {
        const element2 = getBanners.data[j];
        if(element2.estado == true){
          tmpBanners.push({
            imagen: "https://sisep.minedu.gob.bo/strapi/strapi-portal" + element2.imagen.url,
            link: element2.link
          });
        }
      }
      this.banners = tmpBanners;
    } catch (error) {
      this.$snotify.simple("No se pudo obtener datos del servidor :(", {
        timeout: 10000
      })
      console.log(error)
    }
  },
  computed:{
    customHeight: function() {
      return (
        "height:" +
        (this.$store.state.windowSize.h - 64) +
        "px;overflow:hidden;width:100%;background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);"
      );
    },
    masonryStyle() {
      return (this.$store.state.windowSize.w < 800) ? "width:100%" : "width:50%"
    },
    filterByTerm(){
      return this.publicaciones.filter(publicacion => {
        return publicacion.titulo.toUpperCase().includes(this.searchTerm.toUpperCase());
      });
    }
  },
  methods:{
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    scrollToBTabs(){
      let root = document.getElementById('scrolling-techniques-2');
      root.scrollTo({
        top: 612,
        left: 0,
        behavior: 'smooth',
      });
    },
    onChangeTerm(){
      if(this.time){
        clearTimeout(this.time);
      }
      this.time = setTimeout(function(){
        this.$redrawVueMasonry('masonry-grid-1');
        this.$redrawVueMasonry('masonry-grid-2');
      }.bind(this),400);
    },
    updateMan(){
      setTimeout(function(){
        this.$redrawVueMasonry('masonry-grid-1')
        this.$redrawVueMasonry('masonry-grid-2')
      }.bind(this),400);
    },
    abrirPrecarga(){
      this.dialogoPrecarga = true;
      this.value = 0;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        if(this.value == 100){
          clearInterval(this.interval);
          this.value = 95
          setTimeout(()=>{
            this.showFormPopup()
          },1200)
        }
        this.value += 5
      }, 200);
    },
    abrirPrecargaV2(item){
      this.theLinkV2 = "";
      this.dialogoPrecargaV2 = true;
      this.valueV2 = 0;
      clearInterval(this.intervalV2);
      this.intervalV2 = setInterval(() => {
        if(this.valueV2 == 100){
          clearInterval(this.intervalV2);
          this.valueV2 = 95
          setTimeout(()=>{
            this.showFormPopupV2(item)
          },200)
        }
        this.valueV2 += 5
      }, 400);
    },
    cancelarPrecarga(){
      clearInterval(this.interval)
    },
    cancelarPrecargaV2(){
      clearInterval(this.intervalV2)
    },
    showFormPopup(){
      this.dialogoPrecarga = false
      this.dialogoFormulario = true
    },
    showFormPopupV2(item){
      /*this.theLinkV2 = "https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reporteByParametrosAndDepartamento/" + item;
      this.dialogoPrecargaV2 = false
      this.dialogoFormularioV2 = true*/
      this.theLinkV2 = item.ref
      this.dialogoPrecargaV2 = false
      this.dialogoFormularioV2 = true
    }
  },
  async created(){
    if(this.$route.query.view){
      if(this.$route.query.view == 'bibliografia'){
        await this.sleep(500);
        this.currentTab=2;
        await this.sleep(500);
        this.scrollToBTabs();
      }
      else if(this.$route.query.view == 'directrices'){
        await this.sleep(500);
        this.currentTab=3;
        await this.sleep(500);
        this.scrollToBTabs();
      }
    }
  }
};
</script>